import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const MobileApp: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 5.5H10M20 7V17C20 21 19 22 15 22H9C5 22 4 21 4 17V7C4 3 5 2 9 2H15C19 2 20 3 20 7Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 19.1C12.4111 19.1 12.8053 18.9367 13.096 18.646C13.3867 18.3553 13.55 17.9611 13.55 17.55C13.55 17.1389 13.3867 16.7447 13.096 16.454C12.8053 16.1633 12.4111 16 12 16C11.5889 16 11.1947 16.1633 10.904 16.454C10.6133 16.7447 10.45 17.1389 10.45 17.55C10.45 17.9611 10.6133 18.3553 10.904 18.646C11.1947 18.9367 11.5889 19.1 12 19.1Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default MobileApp;
